import { TakerMarket } from '@/enterprise/data/useTakerMarkets';
import useFixedRateDetails from '@/enterprise/features/fixedRate/useFixedRateDetails';
import usePreferredRateDetails from '@/enterprise/features/preferred/usePreferredRateDetails';
import useVariableRateDetails from '@/enterprise/features/variableRate/useVariableRateDetails';
import { useOfferBuilderContext } from './OfferBuilderContext';
import {
  getEffectiveRateFromData,
  getRateComparisonFromData,
  RateHelpers,
  TakerMarketWithRate,
  TakerMarketWithRateComparison,
} from './rateHelpers';
import useDraftRateDetails from './useDraftRateDetails';

export const useRateCalculations = () => {
  const {
    state: { builderVariant, selected, workingTakerMarkets },
  } = useOfferBuilderContext();
  const { getFixedRateDetails } = useFixedRateDetails();
  const { getVariableRateDetails } = useVariableRateDetails();
  const { getPreferredRateDetails } = usePreferredRateDetails();
  const { getDraftRateDetails } = useDraftRateDetails();

  const rateHelpers: RateHelpers = {
    getFixedRate: getFixedRateDetails,
    getVariableRate: getVariableRateDetails,
    getPreferredRate: getPreferredRateDetails,
    getDraftRate: getDraftRateDetails,
  };

  const getEffectiveRate = (tm: TakerMarket) =>
    getEffectiveRateFromData(tm, {
      workingTakerMarkets,
      builderVariant,
      rateHelpers,
    });

  const calculateEffectiveRates = (markets: TakerMarket[] = selected): TakerMarketWithRate[] =>
    markets.map((tm) => ({
      takerMarket: tm,
      ...getEffectiveRate(tm),
    }));

  const calculateRateComparisons = (markets: TakerMarket[] = selected): TakerMarketWithRateComparison[] =>
    markets.map((tm) => ({
      takerMarket: tm,
      ...getRateComparisonFromData(tm, getEffectiveRate, workingTakerMarkets),
    }));

  const getRateComparison = (tm: TakerMarket) => getRateComparisonFromData(tm, getEffectiveRate, workingTakerMarkets);

  return {
    getEffectiveRate,
    getRateComparison,
    calculateEffectiveRates,
    calculateRateComparisons,
  };
};
